import { Address } from "viem";
import CharityList from "./CharityList";
import CharityPie from "./CharityPie";
import { Charity } from "../../../../../models/Charity";

export interface CharityStatisticsProps {
  charities: Charity[];
  you?: Address;
  current?: Address;
}

export default function CharityStatistics(props: CharityStatisticsProps) {
  return (
    <div className="flex flex-col items-center">
      {props.charities.length == 0 ? (
        <div></div>
      ) : (
        <div className={`flex flex-col`} data-aos="fade">
          <span className="font-koulen ~text-base/lg text-gray ~mb-2/3 ~mt-4/8 md:mt-0">
            TOTAL RAISED PER CHARITABLE INSTITUTION
          </span>
          <div className="flex md:flex-row flex-col items-center md:space-x-4 space-y-4 ~mb-5/6">
            {props.charities.some(
              (charity) => charity.donationsReceived.value > 0n,
            ) && <CharityPie charities={props.charities}></CharityPie>}
            <CharityList
              charities={props.charities}
              current={props.current}
              you={props.you}
              showTooltip={true}
            ></CharityList>
          </div>
        </div>
      )}
    </div>
  );
}
